import { createI18n } from 'vue-i18n'
import type { App } from 'vue'
import { localeSetting } from '@/settings/localeSettings'

const { fallback, availableLocales } = localeSetting

export const createI18nOptions = async (locale: string) => {
  const defaultLocal = await import(`./lang/${locale}.ts`)
  const message = defaultLocal.default?.message ?? {}

  return {
    legacy: false,
    locale,
    fallbackLocale: fallback,
    messages: {
      [locale]: message
    },
    availableLocales: availableLocales,
    sync: true, //If you don’t want to inherit locale from global scope, you need to set sync of i18n component option to false.
    silentTranslationWarn: true, // true - warning off
    missingWarn: false,
    silentFallbackWarn: true
  }
}

export let i18n: ReturnType<typeof createI18n>

export const setupI18n = async (app: App) => {
  // TODO: 这里需要从 localstorage 读取 locale
  // const options = await createI18nOptions('zh_CN')
  // const options = await createI18nOptions('en')
  const options = await createI18nOptions(import.meta.env.VITE_APP_I18N_LOCALE)
  i18n = createI18n(options)
  app.use(i18n)
}
